export enum PricingModelEnum {
  CPP = 1,
  CPV,
  FP
}